import { render } from "./BlueShippingPeriodInfo.vue?vue&type=template&id=581e350e&ts=true"
import script from "./BlueShippingPeriodInfo.vue?vue&type=script&lang=ts"
export * from "./BlueShippingPeriodInfo.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__